import React from "react";

/**
 * Compact section-progress indicator. Renders one dot per section:
 *   filled-green = complete, filled-red = has missing required fields,
 *   hollow-grey = optional & not engaged yet (skipped).
 *
 * Hover any dot to see the section label + missing fields.
 * Used in the Receiving page header so the receiver can see at a glance
 * how far through the form they are without scrolling.
 */
export function ProgressDots({ sections, testid }) {
  return (
    <div
      data-testid={testid}
      style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 9px",
               background: "var(--card-2)", borderRadius: 999, border: "1px solid var(--line)" }}
      title="Form progress"
    >
      {sections.map((s) => {
        const state = s.missing.length > 0
          ? "missing"
          : s.skipped ? "skipped" : "complete";
        const styles = {
          missing: { background: "var(--red, #b3261e)", border: "1.5px solid var(--red, #b3261e)" },
          complete: { background: "var(--green, #1f8a4d)", border: "1.5px solid var(--green, #1f8a4d)" },
          skipped: { background: "transparent", border: "1.5px solid var(--line)" },
        }[state];
        const tip = s.missing.length > 0
          ? `${s.label}: missing ${s.missing.join(", ")}`
          : s.skipped ? `${s.label}: not used` : `${s.label}: complete`;
        return (
          <span key={s.key}
            data-testid={testid ? `${testid}-${s.key}-${state}` : undefined}
            title={tip}
            style={{ width: 9, height: 9, borderRadius: "50%", display: "inline-block", ...styles }} />
        );
      })}
    </div>
  );
}
